import formatOpinionHtml from './formatOpinionHtml'
import formatReviewDateTime from './formatReviewDateTime'
import getAdhesionColor from './getAdhesionColor'
import getAssignmentsByRole from './getAssignmentsByRole'
import getStatusBoardPalette from './getStatusBoardPalette'
import hasSentReviewOpinion from './hasSentReviewOpinion'
import isActivityAwaitingApproval from './isActivityAwaitingApproval'
import isActivityInBoardTab from './isActivityInBoardTab'
import isActivityInReview from './isActivityInReview'
import isProjectLocked from './isProjectLocked'
import mountControlLabel from './mountControlLabel'
import mountEvidenceAnchor from './mountEvidenceAnchor'
import mountDpoSteps from './mountNameDpoStages'
import orderAndClearAssignments from './orderAndClearAssignments'

const governanceProject = {
  formatOpinionHtml,
  formatReviewDateTime,
  getAdhesionColor,
  getAssignmentsByRole,
  getStatusBoardPalette,
  hasSentReviewOpinion,
  isActivityAwaitingApproval,
  isActivityInBoardTab,
  isActivityInReview,
  isProjectLocked,
  mountControlLabel,
  mountDpoSteps,
  mountEvidenceAnchor,
  orderAndClearAssignments,
}

export default governanceProject
